import { appConfig } from './app.config';
import { ngxCsv } from 'ngx-csv/ngx-csv';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { Injectable } from '@angular/core';
import { ExcelService } from './shared/services/excel.service';
import { Router } from '@angular/router';
import { SharedService } from './shared/shared.service';
import { getAllLocationData, getLocationHierarchyData, getRegionHierarchyData } from './graphql.queries';
import * as CryptoJS from 'crypto-js';

declare let jsPDF: any;
@Injectable()
export class AppUtils {
    selectedFiles: any = [];
    constructor(public translate: TranslateService,
        public excelService: ExcelService,
        public messageService: MessageService,
        public router: Router,
        public sharedService: SharedService) {
    }
    /**
     * For formatting date
     * @param dateToConvert Date to convert
     * @param type If format required
     */


    formatDate(dateToConvert, type?) {
        let formattedDate = '';
        const date = new Date(Date.parse(dateToConvert));
        const currentMonth = ('0' + (date.getMonth() + 1)).slice(-2);
        const currentDate = ('0' + date.getDate()).slice(-2);
        switch (type) {
            case 'dd/mm/yy':
                formattedDate = `${currentDate}/${currentMonth}/${date.getFullYear()}`;
                break;
            case 'mm/dd/yy':
                formattedDate = `${currentMonth}-${currentDate}-${date.getFullYear()}`;
                break;
            default:
                formattedDate = `${date.getFullYear()}-${currentMonth}-${currentDate}`;
        }
        return formattedDate;
    }

    /**
     * To format time from Date Object
     * @param date Date Object
     */
    formatTime(date) {
        let time: any;
        let hours = date.getHours();
        let minutes = date.getMinutes();
        const timeFormat = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        time = `${hours}:${minutes}${timeFormat}`;
        return time;
    }

    /**
     * To format the data required for p-dropdown
     * @param data Data to format
     */
    augmentDropdownData(data, type?) {
        if (type) {
            const updatedData = data.map((item) => ({
                value: item.comp_dep_id,
                label: item.name,
            }));
            return updatedData;
        } else {
            const updatedData = data.length !== 0 ? data.map((item) => ({
                value: item.id,
                label: item.name ? item.name : item.description
            })) : [];
            return updatedData;
        }
    }

    /**
     * To create names array for Array of objects
     * @param data Data
     */
    createNamesArray(data) {
        const namesArray = [];
        for (const obj of data) {
            namesArray.push(obj.name);
        }
        return namesArray;
    }

    /**
     * For getting logged in user columns from localstorage
     * @param userName Logged in user name
     */
    getLoggedInUserColumns(userName, localStorageKeyName) {
        const getUserColumns = localStorage.getItem(localStorageKeyName);
        let userData = [];
        const localStorageColumns = getUserColumns ? JSON.parse(getUserColumns) : [];
        for (const data of localStorageColumns) {
            if (data.name === userName) {
                userData = data.data;
                break;
            }
        }
        return userData;
    }

    /**
     * For updating the main array after deleting an item from it
     * @param data Array
     * @param deletedId Row to delete id
     */
    updateArrayAfterDelete(data, deletedId) {
        let index;
        for (let i = 0; i < data.length; i++) {
            if (data[i].id === deletedId) {
                index = i;
            }
        }
        return data.filter((value, i) => i !== index);
    }

    /**
     * Used to check if input length > 0 then cross sign should show in search input
     * @param value Input to be search
     */
    checkSearchFilterLength(value) {
        let valueExist = false;
        if (value.length > 0) {
            valueExist = true;
        } else {
            valueExist = false;
        }
        return valueExist;
    }

    tempaugmentHierarchyData(dataList, depth, counter, updatedList, columns) {
        if (dataList) {
            for (let i = counter; i <= dataList.length - 1; i += 1) {
                let hierarchyObj;
                let nonZeroAIVOrItem = 0;
                const obj = dataList[i];
                if (dataList[i].qty != null && dataList[i].amt != null && dataList[i].qty !== 0) {
                    obj.aiv = dataList[i].amt / dataList[i].qty;
                } else {
                    obj.aiv = 0;
                }
                if (dataList[i].customer_qty !== 0 && dataList[i].customer_qty != null) {
                    obj.items_per_ticket = dataList[i].qty / dataList[i].customer_qty;
                } else {
                    obj.items_per_ticket = 0;
                }
                if (dataList[i].net_sales_amt != null && dataList[i].customer_qty !== 0 && dataList[i].customer_qty != null) {
                    obj.atv = dataList[i].amt / dataList[i].customer_qty;
                } else {
                    obj.atv = 0;
                }
                if (obj.depth === depth) {
                    hierarchyObj = {
                        data: obj,
                        children: this.tempaugmentHierarchyData(dataList, depth + 1, i + 1, [], columns),
                    };
                }
                if (hierarchyObj && hierarchyObj.children.length) {
                    for (const childKey of columns) {
                        let data = {};
                        if (childKey != "name") {
                            data = this.calculateColumnSum(hierarchyObj.children, childKey);

                            hierarchyObj.data[childKey] = data["value"];
                            if (data != null && data["childWithNonZero"] != 0) {
                                nonZeroAIVOrItem = data["childWithNonZero"];
                            }
                        }
                    }
                } else if (hierarchyObj) {
                    for (const parentKey of columns) {
                        if (hierarchyObj.data[parentKey] === null) {
                            hierarchyObj.data[parentKey] = 0;
                        }
                    }
                }
                if (obj.depth < depth) {
                    break;
                }
                if (hierarchyObj) {
                    if (hierarchyObj.children.length != 0 && nonZeroAIVOrItem != 0) {
                        hierarchyObj.data["aiv"] = hierarchyObj.data["amt"] / hierarchyObj.data["qty"];
                        hierarchyObj.data["items_per_ticket"] = hierarchyObj.data["qty"] / hierarchyObj.data["customer_qty"];
                        hierarchyObj.data["atv"] = hierarchyObj.data["amt"] / hierarchyObj.data["customer_qty"];
                    }
                    if (hierarchyObj.children) {
                        if (hierarchyObj.children.length > 0) {
                            let sortedHierarchy = this.getSortedHierarchy(hierarchyObj.children);
                            let sortedArray = this.getFinalArray(sortedHierarchy);
                            let finalSortedArray: any = {};
                            finalSortedArray.data = hierarchyObj.data;
                            finalSortedArray.children = sortedArray;
                            updatedList.push(finalSortedArray);
                        } else {
                            updatedList.push(hierarchyObj);
                        }
                    }
                }
            }
        }
        updatedList = updatedList.reverse();
        return updatedList;
    }

    paginationFilter(type, pageData) {
        pageData = this.updateSearchFlag(type, pageData);
        if (type.first === 0 && type.sortField) {
            if (pageData.offset === 2 && type.sortField === pageData.prevSortField && type.sortOrder === pageData.prevSortOrder) {
                pageData.offset = 1;
            }
            else {
                type.first = (pageData.offset - 1) * pageData.limit;
            }
        }
        if (!pageData.limit === type.rows) {
            pageData.limit = type.rows;
            pageData.offset = 1;
        } else {

            pageData.limit = type.rows;
            pageData.offset = Math.ceil(type.first / pageData.limit) + 1;
        }
        pageData.searchText = type.globalFilter ? type.globalFilter.trim() : '';
        pageData.sortField = type.sortField ? type.sortField : "name";
        pageData.prevSortField = type.sortField ? type.sortField : '';
        pageData.sortOrder = "ASC";
        pageData.prevSortOrder = 1;
        if (type.sortOrder === -1) {
            pageData.sortOrder = "DESC";
            pageData.prevSortOrder = -1;
        }
        return pageData;
    }

    updateSearchFlag(type: any, pageData: any) {
        pageData.search = false;
        const filterValue = type?.globalFilter?.key === 'Enter' ?
            type.globalFilter?.target?.value?.trim() ? type.globalFilter?.target?.value : '' : type.globalFilter?.trim();

        if (type?.globalFilter?.key === 'Enter' && filterValue?.length <= 2 && filterValue?.length > 0) {
            type.globalFilter = type.globalFilter?.target?.value;
            pageData.search = true;
        }
        else if (type?.globalFilter?.key === 'Enter' && filterValue?.length === 0) {
            type.globalFilter = type.globalFilter?.target?.value;
            pageData.search = false;
        }
        else if (type.globalFilter === null || filterValue?.length >= 3) {
            pageData.search = true;
        }
        return pageData;
    }

    getSortedHierarchy(data, type?) {
        if (type == 'dropdown') {
            data.sort(function (a, b) {
                if (a.label.toLowerCase() < b.label.toLowerCase()) {
                    return -1;
                } else if (a.label.toLowerCase() > b.label.toLowerCase()) {
                    return 1;
                } else {
                    return 0;
                }
            });
            return data;
        } else if (type == 'storeDept') {
            data.sort(function (a, b) {
                if (a.data.description.toLowerCase() < b.data.description.toLowerCase()) {
                    return -1;
                } else if (a.data.description.toLowerCase() > b.data.description.toLowerCase()) {
                    return 1;
                } else {
                    return 0;
                }
            });
            return data;
        } else {
            data.sort(function (a, b) {
                if (a.data.name.toLowerCase() < b.data.name.toLowerCase()) {
                    return -1;
                } else if (a.data.name.toLowerCase() > b.data.name.toLowerCase()) {
                    return 1;
                } else {
                    return 0;
                }
            });
            return data;
        }
    }
    /**
     * To get final array
     * @param data
     */
    getFinalArray(data) {
        let hierarchyArray: any = [];
        let nonHierarchyArray: any = [];
        let finalArray: any = [];
        data.forEach(element => {
            if (element.children.length > 0) {
                hierarchyArray.push(element);
            }
            else {
                nonHierarchyArray.push(element);
            }
        });
        finalArray = hierarchyArray;
        nonHierarchyArray.forEach(element => {
            finalArray.push(element);
        });
        return finalArray;
    }

    locationFilter(data, type?) {
        let finalResultLocation: Array<any> = [];
        let locationListData: any;
        if (type == 'department') {
            locationListData = { response: data, label: "name", data: "dep_loc_id", locationId: "department_id", groupId: "group_id", idType: "parentOnly", type: "location" };
        } else {
            locationListData = { response: data, label: "name", data: "reg_loc_id", locationId: "location_id", idType: "parentOnly", type: "location" };
        }

        let arr = [];
        let depth: number = 0;
        let counter: number = 0;
        for (let i = 0; i < locationListData.response.length; i++) {
            arr.push({
                data: locationListData.response[i][locationListData.data],
                locationId: locationListData.response[i][locationListData.locationId],
                groupId: locationListData.response[i][locationListData.groupId],
                label: locationListData.response[i][locationListData.label], depth: locationListData.response[i].depth,
                posId: locationListData.response[i].pos_id,
                authorityLevel: locationListData.response[i]?.authorityLevel ?? null,
                selected: locationListData.response[i].selected,
                bookmark: locationListData.response[i].bookmark
            });
        }
        let dptHierarchyResponse = this.genericHierarchyCheckbox(arr, depth, counter, []);
        dptHierarchyResponse = this.getSortedHierarchy(dptHierarchyResponse, 'dropdown');
        let hierarchyArr: any = [];
        let nonHierarchyArr: any = [];
        for (let i = 0; i < dptHierarchyResponse.length; i++) {

            if (dptHierarchyResponse[i].children.length) {
                hierarchyArr.push(dptHierarchyResponse[i]);
            } else {
                nonHierarchyArr.push(dptHierarchyResponse[i]);
            }
        }
        this.getParentId(hierarchyArr, []);
        finalResultLocation = hierarchyArr;
        for (let k = 0; k < nonHierarchyArr.length; k++) {
            finalResultLocation.push(nonHierarchyArr[k]);
        }
        let finalData = [{ data: null, locationId: null, expanded: true, leaf: true, label: "Select All", depth: 0, children: finalResultLocation }]
        return { finalResultLocation: finalData, locationListData: locationListData };
    }

    isMultiHierarchySameSelected(a, b) {
        if (a.length != b.length)
            return false;
        else {
            var arr1 = a.sort();
            var arr2 = b.sort();
            var isEqualVal = true;
            // comapring each element of array
            for (var i = 0; i < arr1.length; i++) {
                if (arr1[i] != arr2[i]) {
                    isEqualVal = false;
                    break;
                }
            }
            if (isEqualVal) {
                return true;
            } else {
                return false;
            }

        }
    }

    getParentId(data, parentList) {
        for (let i = 0; i < data.length; i++) {
            data[i].parentIds = parentList;
            if (data[i].children.length) {
                let temp: any = [];
                for (let j = 0; j < data[i].parentIds.length; j++) {
                    temp.push(data[i].parentIds[j])
                }
                temp.push(data[i].data)
                return this.getParentId(data[i].children, temp);
            }
        }
    }

    getDropdownAdditional(finalResultLocation, locationListData, type?) {
        let selectedLocationId = [];
        let groupIds = [];
        let selectedGroupIds = [];
        const selectedDropdownLocationValue = [];
        if (type === 'department') {
            selectedLocationId = [];
        } else if (type === 'departmentAll') {
            for (let i = 0; i < locationListData.response.length; i++) {
                if (locationListData.response[i].pos_id && locationListData.response[i].pos_id !== null) {
                    selectedLocationId.push(locationListData.response[i].pos_id);
                }
            }
        } else if (type === 'departmentItem') {
            selectedLocationId = localStorage.getItem('departmentLocId')
                ? JSON.parse(localStorage.getItem('departmentLocId')) : '';
        } else if (type === 'itemDepartmentItem') {
            selectedLocationId = localStorage.getItem('itemDepartmentLocId')
                ? JSON.parse(localStorage.getItem('itemDepartmentLocId')) : '';
        } else if (type === 'posReports') {
            selectedLocationId = localStorage.getItem('posSelectedLocationId')
                ? JSON.parse(localStorage.getItem('posSelectedLocationId')) : '';
        }
        // To get the selected location list
        else if (type === 'sheetData') {
            selectedLocationId = localStorage.getItem('sheetSelectedLocationId')
                ? JSON.parse(localStorage.getItem('sheetSelectedLocationId')) : '';
        }
        else {
            if (type === 'selectedOverviewLocId' && localStorage.getItem('selectedLocationIdOverview')) {
                selectedLocationId = JSON.parse(localStorage.getItem('selectedLocationIdOverview'));
            } else if (type === 'selectedStoreOverviewLocId' && localStorage.getItem('selectedLocationIdStoreOverview')) {
                selectedLocationId = JSON.parse(localStorage.getItem('selectedLocationIdStoreOverview'));
            } else if (type === 'selectedTerminalOverviewLocId' && localStorage.getItem('selectedLocationIdTerminal')) {
                selectedLocationId = JSON.parse(localStorage.getItem('selectedLocationIdTerminal'));
            } else if (type === 'selectedDepartmentLocId' && localStorage.getItem('selectedLocationIdDepartment')) {
                selectedLocationId = JSON.parse(localStorage.getItem('selectedLocationIdDepartment'));
            } else if (type === 'selectedStoreDepartmentLocId' && localStorage.getItem('selectedLocationIdStoreDepartment')) {
                selectedLocationId = JSON.parse(localStorage.getItem('selectedLocationIdStoreDepartment'));
            } else if (type === 'selectedItemsLocId' && localStorage.getItem('selectedLocationIdItems')) {
                selectedLocationId = JSON.parse(localStorage.getItem('selectedLocationIdItems'));
            } else if (type === 'selectedTendarLocId' && localStorage.getItem('selectedLocationIdTender')) {
                selectedLocationId = JSON.parse(localStorage.getItem('selectedLocationIdTender'));
            } else if (type === 'selectedStoreTendarLocId' && localStorage.getItem('selectedLocationIdStoreTender')) {
                selectedLocationId = JSON.parse(localStorage.getItem('selectedLocationIdStoreTender'));
            } else if (type === 'selectedSumaaryLocId' && localStorage.getItem('selectedLocationIdSummary')) {
                selectedLocationId = JSON.parse(localStorage.getItem('selectedLocationIdSummary'));
            } else if (type === 'selectedCashierLocId' && localStorage.getItem('selectedLocationIdCashiers')) {
                selectedLocationId = JSON.parse(localStorage.getItem('selectedLocationIdCashiers'));
            } else if (type === 'selectedTransactionLocId' && localStorage.getItem('selectedLocationIdTransaction')) {
                selectedLocationId = JSON.parse(localStorage.getItem('selectedLocationIdTransaction'));
            } else if (type === 'selectedAnalyticsLocId' && localStorage.getItem('selectedLocationIdAnalytics')) {
                selectedLocationId = JSON.parse(localStorage.getItem('selectedLocationIdAnalytics'));
            } else if (type === 'selectedDoubleUpLocId' && localStorage.getItem('selectedLocationIdsDoubleUp')) {
                selectedLocationId = JSON.parse(localStorage.getItem('selectedLocationIdsDoubleUp'));
            } else if (type === 'selectedLaneRebootLocId' && localStorage.getItem('selectedLocationIdsLaneReboot')) {
                selectedLocationId = JSON.parse(localStorage.getItem('selectedLocationIdsLaneReboot'));
            } else if (type === 'selectedDigitalReceiptLocId' && localStorage.getItem('selectedLocIdsDigitalReceipt')) {
                selectedLocationId = JSON.parse(localStorage.getItem('selectedLocIdsDigitalReceipt'));
            } else {
                if (localStorage.getItem('selectedLocationId')) {
                    selectedLocationId = JSON.parse(localStorage.getItem('selectedLocationId'));
                } else {
                    for (let i = 0; i < locationListData?.response?.length; i++) {
                        selectedLocationId.push(locationListData.response[i].reg_loc_id);
                    }
                }
            }
        }
        if (locationListData?.response?.length > 0) {
            for (let i = 0; i < locationListData.response.length; i++) {
                if (locationListData.response[i]?.group_id && locationListData.response[i].group_id !== null &&
                    locationListData.response[i].depth === 0) {
                    groupIds.push(locationListData.response[i].group_id);
                }
            }
        }
        this.selectedFiles = [];
        if (type === 'itemDepartmentItem') {
            selectedGroupIds = localStorage.getItem('selectedItemGroupId') ?
                JSON.parse(localStorage.getItem('selectedItemGroupId')) : groupIds;
        } else {
            selectedGroupIds = localStorage.getItem('selectedGroupId') ?
                JSON.parse(localStorage.getItem('selectedGroupId')) : groupIds;
        }
        this.checkNode(finalResultLocation, selectedLocationId, selectedGroupIds);
        for (let i = 0; i < this.selectedFiles.length; i++) {
            if (this.selectedFiles[i].leaf && this.selectedFiles[i].locationId) {
                selectedDropdownLocationValue.push(this.selectedFiles[i]);
            }
        }
        return { selectedLocationId: selectedLocationId, selectedDropdownLocationValue: selectedDropdownLocationValue, finalList: this.selectedFiles, groupIds: groupIds }
    }

    checkNode(nodes: any, str: any[], grpId: any[]) {
        for (let i = 0; i < nodes?.length; i++) {
            if (!nodes[i].leaf && nodes[i].children[0].leaf) {
                for (let j = 0; j < nodes[i].children.length; j++) {
                    if (nodes[i].children[j].groupId && nodes[i].children[j].groupId !== undefined) {
                        if (str.includes(nodes[i].children[j].data) && grpId.includes(nodes[i].children[j].groupId)) {
                            if (!this.selectedFiles.includes(nodes[i].children[j])) {
                                this.selectedFiles.push(nodes[i].children[j]);
                            }
                        }
                    } else {
                        if (str.includes(nodes[i].children[j].data)) {
                            if (!this.selectedFiles.includes(nodes[i].children[j])) {
                                this.selectedFiles.push(nodes[i].children[j]);
                            }
                        }
                    }
                }
            } else if (nodes[i].leaf) {
                if (nodes[i].groupId && nodes[i].groupId !== undefined) {
                    if (str.includes(nodes[i].data) && grpId.includes(nodes[i].groupId)) {
                        if (!this.selectedFiles.includes(nodes[i])) {
                            this.selectedFiles.push(nodes[i]);
                        }
                    }
                } else {
                    if (str.includes(nodes[i].data)) {
                        if (!this.selectedFiles.includes(nodes[i])) {
                            this.selectedFiles.push(nodes[i]);
                        }
                    }
                }
            }
            this.checkNode(nodes[i].children, str, grpId);
            const count = nodes[i].children.length;
            let c = 0;
            for (let j = 0; j < nodes[i].children.length; j++) {
                if (this.selectedFiles.includes(nodes[i].children[j])) {
                    c++;
                }
                if (nodes[i].children[j].partialSelected) {
                    nodes[i].partialSelected = true;
                }
            }
            if (c === 0) { } else if (c === count) {
                nodes[i].partialSelected = false;
                if (!this.selectedFiles.includes(nodes[i])) {
                    this.selectedFiles.push(nodes[i]);
                }
            } else {
                nodes[i].partialSelected = true;
            }
        }
    }

    checkRegex(text) {
        if (/^[@.:\-0-9a-zA-Z\s]*$/.test(text)) {
            return true;
        } else {
            this.showToasterMessage('error', 'MESSAGES.MESSAGE_VALIDATION', '');
            return false;
        }
    }

    nodeSelection(file, locationId, finalList, locationLabel, event, type) {
        locationLabel = [];
        this.selectedFiles = file;
        for (let i = 0; i < this.selectedFiles.length; i++) {
            if (this.selectedFiles[i].leaf && this.selectedFiles[i].locationId) {
                locationLabel.push(this.selectedFiles[i]);
            }
        }
        for (let i = 0; i < file.length; i++) {
            locationId.push(file[i].data);
            if (type === 'department') {
                this.getAllParent(file[i].parent, locationId);
            }
        }
        for (let i = 0; i < file.length; i++) {
            if (file[i].parentIds) {
                for (let j = 0; j < file[i].parentIds.length; j++) {
                    if (locationId.indexOf(file[i].parentIds[j]) < 0) {
                        locationId.push(file[i].parentIds[j]);
                    }
                }
            }
        }
        return { locationId: Array.from(new Set(locationId)), finalList: file, locationLabel: locationLabel };
    }

    departmentNodeSelection(file: any, locationId: any, locationLabel: any, groupId: any) {
        locationLabel = [];
        this.selectedFiles = file;
        for (let i = 0; i < this.selectedFiles.length; i++) {
            if (this.selectedFiles[i].leaf && this.selectedFiles[i].locationId) {
                locationLabel.push(this.selectedFiles[i]);
            }
        }
        for (let i = 0; i < file.length; i++) {
            if (file[i].locationId && file[i].locationId !== null) {
                locationId.push(file[i].locationId);
            }
            if (file[i].groupId && file[i].groupId !== null) {
                groupId.push(file[i].groupId);
            }
            this.getAllDepParent(file[i].parent, locationId, groupId);
        }
        return { locationId: Array.from(new Set(locationId)), finalList: file, locationLabel: locationLabel, groupId: Array.from(new Set(groupId)) };
    }

    getAllDepParent(parentNode: any, locationId: any, groupId?: any) {
        if (parentNode && (locationId.indexOf(parentNode.data) !== 0) && parentNode.data !== null) {
            groupId.push(parentNode.data);
            return this.getAllParent(parentNode.parent, locationId);
        }
    }

    getAllParent(parentNode: any, locationId: any) {
        if (parentNode && (locationId.indexOf(parentNode.data) !== 0) && parentNode.data !== null) {
            locationId.push(parentNode.data);
            return this.getAllParent(parentNode.parent, locationId);
        }
    }



    getSelectedData(data, type, locationId, locationValue, finalList) {
        if (type == 'location') {
            if (finalList.selectedRegionId.indexOf(data.reg_loc_id) < 0) {
                finalList.selectedRegionId.push(data.reg_loc_id);
                for (let i = 0; i < finalList.linkedLocationId.length; i++) {
                    if (finalList.linkedLocationId[i].reg_loc_id == data.reg_loc_id) {
                        for (let j = 0; j < finalList.linkedLocationId[i].childId.length; j++) {
                            locationId.push(finalList.linkedLocationId[i].childId[j]);
                        }
                    }
                }
                locationValue.push(data.label)
                setTimeout(function () {
                    data.checked = true;
                }, 0)
            } else {
                finalList.selectedRegionId.splice(finalList.selectedRegionId.indexOf(data.reg_loc_id), 1);
                for (let i = 0; i < finalList.linkedLocationId.length; i++) {
                    if (finalList.linkedLocationId[i].reg_loc_id == data.reg_loc_id) {
                        for (let j = 0; j < finalList.linkedLocationId[i].childId.length; j++) {
                            locationId.splice(locationId.indexOf(finalList.linkedLocationId[i].childId[j]), 1);
                        }
                    }
                }
                locationValue.splice(locationValue.indexOf(data.label), 1);
                setTimeout(function () {
                    data.checked = false;
                }, 0)
            }
        }
        return { data: data, locationId: locationId, locationValue: locationValue };
    }

    /**
     * To Augment the data required for p-treetable
     * @param dataList Response
     * @param depth Depth to start 0
     * @param counter Counter to start 0
     * @param updatedList Updated Array
     * @param columns Columns Array
     */
    augmentHierarchyData(dataList, depth, counter, updatedList, columns) {
        if (dataList) {
            for (let i = counter; i <= dataList.length - 1; i += 1) {
                let hierarchyObj;
                let nonZeroAIVOrItem = 0;
                const obj = dataList[i];
                if (dataList[i].dep_id && dataList[i].dep_id != null) {
                    if (dataList[i].net_sales_qty != 0 && dataList[i].net_sales_qty != null && dataList[i].net_sales_amt != null) {
                        obj.aiv = dataList[i].net_sales_amt / dataList[i].net_sales_qty;
                    } else {
                        obj.aiv = 0;
                    }
                    if (dataList[i].customer_qty != 0 && dataList[i].customer_qty != null) {
                        obj.items_per_ticket = dataList[i].net_sales_qty / dataList[i].customer_qty;
                    } else {
                        obj.items_per_ticket = 0;
                    }

                    if (dataList[i].net_sales_amt != null && dataList[i].customer_qty != 0 && dataList[i].customer_qty != null) {
                        obj.atv = dataList[i].net_sales_amt / dataList[i].customer_qty;
                    } else {
                        obj.atv = 0;
                    }
                }
                if (obj.depth === depth) {
                    hierarchyObj = {
                        data: obj,
                        children: this.augmentHierarchyData(dataList, depth + 1, i + 1, [], columns),
                    };
                }
                if (hierarchyObj && hierarchyObj.children.length) {
                    for (const childKey of columns) {
                        let data = {};
                        if (childKey != "customer_qty") {
                            data = this.calculateColumnSum(hierarchyObj.children, childKey);
                            hierarchyObj.data[childKey] = data["value"];
                        }
                        if (data != null && data["childWithNonZero"] != 0) {
                            nonZeroAIVOrItem = data["childWithNonZero"];
                        }

                    }
                } else if (hierarchyObj) {
                    for (const parentKey of columns) {
                        if (hierarchyObj.data[parentKey] === null) {
                            hierarchyObj.data[parentKey] = 0;
                        }
                    }
                }
                if (obj.depth < depth) {
                    break;
                }
                if (hierarchyObj) {
                    if (hierarchyObj.children.length != 0 && nonZeroAIVOrItem != 0) {
                        // hierarchyObj.data["aiv"] = hierarchyObj.data["aiv"] / nonZeroAIVOrItem;
                        // hierarchyObj.data["items_per_ticket"] = hierarchyObj.data["items_per_ticket"] / nonZeroAIVOrItem;
                        // hierarchyObj.data["atv"] = hierarchyObj.data["atv"] / nonZeroAIVOrItem;
                        if (hierarchyObj.data['net_sales_qty'] !== 0 && hierarchyObj.data['net_sales_qty'] != null
                            && hierarchyObj.data['net_sales_amt'] != null) {
                            hierarchyObj.data['aiv'] = hierarchyObj.data['net_sales_amt'] / hierarchyObj.data['net_sales_qty'];
                        }
                        if (hierarchyObj.data['customer_qty'] !== 0 && hierarchyObj.data['customer_qty'] != null) {
                            hierarchyObj.data['items_per_ticket'] = hierarchyObj.data['net_sales_qty'] / hierarchyObj.data['customer_qty'];
                        }
                        if (hierarchyObj.data['net_sales_amt'] != null &&
                            hierarchyObj.data['customer_qty'] !== 0 && hierarchyObj.data['customer_qty'] != null) {
                            hierarchyObj.data['atv'] = hierarchyObj.data['net_sales_amt'] / hierarchyObj.data['customer_qty'];
                        }
                    }
                    if (hierarchyObj.children) {
                        if (hierarchyObj.children.length > 0) {
                            let sortedHierarchy = this.getSortedHierarchy(hierarchyObj.children);
                            let sortedArray = this.getFinalArray(sortedHierarchy);
                            let finalSortedArray: any = {};
                            finalSortedArray.data = hierarchyObj.data;
                            finalSortedArray.children = sortedArray;
                            updatedList.push(finalSortedArray);
                        }
                        else {
                            updatedList.push(hierarchyObj);
                        }
                    }
                }
            }
        }
        return updatedList;
    }

    /** To Data Point Reporting store department  */
    augmentHierarchyDataDPRStore(dataList, depth, counter, updatedList, columns) {
        if (dataList) {
            for (let i = counter; i <= dataList.length - 1; i += 1) {
                let hierarchyObj;
                let nonZeroAIVOrItem = 0;
                const obj = dataList[i];
                if (obj.depth === depth) {
                    hierarchyObj = {
                        data: obj,
                        children: this.augmentHierarchyDataDPRStore(dataList, depth + 1, i + 1, [], columns),
                    };
                }
                if (hierarchyObj && hierarchyObj.children.length) {
                    for (const childKey of columns) {
                        let data = {};
                        if (childKey != "customer_qty") {
                            data = this.calculateColumnSum(hierarchyObj.children, childKey);
                            hierarchyObj.data[childKey] = data["value"];
                        }
                        if (data != null && data["childWithNonZero"] != 0) {
                            nonZeroAIVOrItem = data["childWithNonZero"];
                        }
                    }
                } else if (hierarchyObj) {
                    for (const parentKey of columns) {
                        if (hierarchyObj.data[parentKey] === null) {
                            hierarchyObj.data[parentKey] = 0;
                        }
                    }
                }
                if (obj.depth < depth) {
                    break;
                }
                if (hierarchyObj) {
                    if (hierarchyObj.children) {
                        if (hierarchyObj.children.length > 0) {
                            let sortedHierarchy = this.getSortedHierarchy(hierarchyObj.children, 'storeDept');
                            let sortedArray = this.getFinalArray(sortedHierarchy);
                            let finalSortedArray: any = {};
                            finalSortedArray.data = hierarchyObj.data;
                            finalSortedArray.children = sortedArray;
                            updatedList.push(finalSortedArray);
                        }
                        else {
                            updatedList.push(hierarchyObj);
                        }
                    }
                }
            }
        }
        return updatedList;
    }

    /**
     * To calculate the total sum to display in Parent Node in Hierarchy list
     * @param data Response
     * @param key Column sum to calculate
     */
    calculateColumnSum(data, key) {
        let value = 0;
        let childWithNonZero = 0;
        let dataObj = {};
        data.forEach(element => {
            value += Number(element.data[key]);
            if (key == "aiv" || key == "atv" && element.data["aiv"] != 0 || element.data["atv"] != 0) {
                childWithNonZero++;
            }
        });

        dataObj["childWithNonZero"] = childWithNonZero;
        if (Number.isInteger(value)) {
            dataObj["value"] = value;
            return dataObj;
        } else {
            dataObj["value"] = value.toFixed(2);
            return dataObj;
        }
    }

    /**
     * To validate the date pattern based on defined pattern in Internationalization file
     * @param date Selected date
     * @param pattern Date format pattern
     */
    validatePattern(date, pattern) {
        const validDate = new RegExp(pattern);
        return validDate.test(date);
    }

    /**
     * To validate start and end dates while filtering in table
     * @param data Data to validate
     */
    validateStartEndDates(data) {
        let valDataExist = false;
        const valStartDateExist = this.validatePattern(
            this.formatDate(data.dates.startDate, data.translate.instant('FORMATS.DATE')), data.translate.instant('FORMATS.DATE_PATTERN'));
        const valEndDateExist = this.validatePattern(
            this.formatDate(data.dates.endDate, data.translate.instant('FORMATS.DATE')), data.translate.instant('FORMATS.DATE_PATTERN'));
        if (data.dates.startDate === null && data.dates.endDate === null) {
            data.startDateError = true;
            data.endDateError = true;
            data.msgService.add({
                severity: 'error', summary: data.translate.instant('MESSAGES.VALID_DATES') + ' ' + data.translate.instant('FORMATS.DATE')
            });
        } else if (data.dates.startDate === null) {
            data.startDateError = true;
            data.endDateError = false;
            data.msgService.add({
                severity: 'error', summary: data.translate.instant('MESSAGES.VALID_START_DATE')
                    + ' ' + data.translate.instant('FORMATS.DATE')
            });
        } else if (data.dates.endDate === null) {
            data.endDateError = true;
            data.startDateError = false;
            data.msgService.add({
                severity: 'error', summary: data.translate.instant('MESSAGES.VALID_END_DATE') + ' ' + data.translate.instant('FORMATS.DATE')
            });
        } else if (new Date(data.dates.startDate).getTime() > new Date(data.dates.endDate).getTime()) {
            data.startDateError = true;
            data.endDateError = false;
            data.msgService.add({ severity: 'error', summary: data.translate.instant('MESSAGES.START_DATE_VALIDATION') });
        } else if (new Date(data.dates.endDate).getTime() < new Date(data.dates.startDate).getTime()) {
            data.endDateError = true;
            data.startDateError = false;
            data.msgService.add({ severity: 'error', summary: data.translate.instant('MESSAGES.END_DATE_VALIDATION') });
        } else {
            data.startDateError = false;
            data.endDateError = false;
            if (valStartDateExist && (data.dates.endDate ? valEndDateExist : true)) {
                valDataExist = true;
            }
        }
        data['valDataExist'] = valDataExist;
        return data;
    }

    /**
     * To get start and end dates from localstorage if exist
     */
    getStartEndDates() {
        const dateObject = {
            startDate: new Date(),
            endDate: new Date()
        };
        const selectedDates = localStorage.getItem('startEndDates') ? JSON.parse(localStorage.getItem('startEndDates')) : {};
        dateObject.startDate = selectedDates.startDate ? new Date(selectedDates.startDate) : new Date();
        dateObject.endDate = selectedDates.endDate ? new Date(selectedDates.endDate) : new Date();
        return dateObject;
    }

    getStartEndDatesNew() {
        let selectedDates: any = [];
        selectedDates = localStorage.getItem('startEndDatesNew') ? JSON.parse(localStorage.getItem('startEndDatesNew')) : [new Date(), new Date()];
        return selectedDates;
    }

    /**
     * To add the label key in the columns converting table header name based on Internationalization
     * @param cols Col group to add key
     * @param translate Translate Instance
     */
    augmentTableCols(cols, translate) {
        cols.loggedInCol.forEach((col) => {
            col['label'] = translate.instant(col.header);
        });
        cols.main.forEach((col) => {
            col['label'] = translate.instant(col.header);
        });
        cols.default.forEach((col) => {
            col['label'] = translate.instant(col.header);
        });

        return cols;
    }

    formatDateTime(date, type) {
        if (type == "date") {
            return date.split("T")[0];
        } else {
            return date.split("T")[1];
        }
    }

    /**
     * To augment the cols required while exporting else it will render name as 'COMMON.LOCATION'
     * @param cols Cols header to change
     * @param translate Translate Service
     */
    augmentTableExportCols(cols, translate) {
        cols.forEach(col => {
            col.header = translate.instant(col.header);
        });
        return cols;
    }

    /**
     * To save columns order on show/hide and drag/drop
     * @param event Dropdown event
     * @param data Data to save
     * @param type Single Change or Remove All
     */
    saveColumnsOrder(event, data, type?) {
        data.userColumns.name = data.userName;
        if (type === 'CHANGE_FROM_DROPDOWN') {
            data.userColumns.data = event.value;
        } else if (type === 'REMOVE_ALL') {
            data.userColumns.data = event;
        } else {
            data.userColumns.data = event.columns;
        }
        if (data.columnsData && data.columnsData.length) {
            let counter = 0;
            let objFound = false;
            for (const dataObj of data.columnsData) {
                if (data.userColumns.name === dataObj.name) {
                    data.columnsData[counter] = data.userColumns;
                    objFound = true;
                    break;
                }
                counter++;
            } if (!objFound) {
                data.columnsData.push(data.userColumns);
            }
        } else {
            data.columnsData.push(data.userColumns);
        }
        localStorage.setItem(data.orderName, JSON.stringify(data.columnsData));
    }

    /**
     * To change the frozen col width in mobile view
     * @param width Col width
     */
    changeFrozenColWidth(width) {
        let updatedWidth = '';
        const windowWidth = window.innerWidth;
        if (windowWidth <= 480) {
            updatedWidth = '180px';
        } else {
            updatedWidth = width;
        }
        return updatedWidth;
    }

    /**
     * To remove Ids from response, to prevent it from displaying in csv
     * @param data Response
     */
    removeIds(data) {
        for (let i = 0; i < data.length; i++) {
            if (data[i].id) {
                delete data[i].id;
            } else if (data[i].item_id && data[i].location_id) {
                delete data[i].item_id;
                delete data[i].location_id;
            } else if (data[i].cashier_id) {
                delete data[i].cashier_id;
            } else if (data[i].userId) {
                delete data[i].userId;
            }
        }
        return data;
    }

    /**
     * A comman method for formatting the data to be exported.
     * @param objectData Current object in which we have to do the changes.
     */

    conditionalExportFormatting(objectData: any, opts?: { calculatingTotal: boolean, fieldsToAvoid: Array<string> }) {
        if (objectData.aiv && objectData.aiv !== null && objectData.aiv !== 0) {
            objectData.aiv = Number(objectData.aiv).toFixed(2);
        }
        if (objectData.items_per_ticket && objectData.items_per_ticket !== null && objectData.items_per_ticket !== 0) {
            objectData.items_per_ticket = Number(objectData.items_per_ticket).toFixed(2);
        }
        if (objectData.atv && objectData.atv !== null && objectData.atv !== 0) {
            objectData.atv = Number(objectData.atv).toFixed(2);
        }
        for (var key in objectData) {
            if (objectData.hasOwnProperty(key)) {
                objectData[key] = objectData[key] === null ? 0 :
                    Number.isNaN(objectData[key]) ? 0 :
                        objectData[key] === undefined ? 0 :
                            objectData[key];
            }
            let obj: any;
            obj = Number(objectData[key]);
            if (!Number.isNaN(obj)) {
                objectData[key] = obj;
            }
            if (key == 'credit') {
                objectData[key] === 'credit' ? objectData[key] = '' : objectData[key] = objectData[key];
            }
            if (key == 'debit') {
                objectData[key] === 'debit' ? objectData[key] = '' : objectData[key] = objectData[key];
            }
        }

        if (opts) {
            if (objectData.name === 'Total') {
                opts.fieldsToAvoid.forEach((field) => {
                    if (objectData.hasOwnProperty(field)) {
                        objectData[field] = '';
                    }
                })
            }
        }
        return objectData;
    }

    /**
     * To export the JSON data to CSV format
     * @param data Response
     * @param headers CSV file headers
     * @param fileName Downloaded file name
     */
    exportData(data, headerModal, fileName, type, opts = { calculatingTotal: false, fieldsToAvoid: [] }) {
        let headers: any = []
        let rows: any = [];
        for (let i = 0; i < headerModal.length; i++) {
            if (headerModal[i]?.header !== '') {
                let temp: any = this.translate.instant(headerModal[i]?.header);
                headers.push(temp);
            } else {
                headers.push('');
            }
        }

        switch (type) {
            case 'csv':
                for (let j = 0; j < data.length; j++) {
                    let obj: any = {};
                    for (let k = 0; k < headerModal.length; k++) {
                        obj[headerModal[k].field] = data[j][headerModal[k].field];
                    }
                    obj = this.conditionalExportFormatting(obj, opts);
                    rows.push(obj);
                }
                let dataToExport = [];
                const clonedData = JSON.parse(JSON.stringify(rows));
                dataToExport = clonedData;
                if (opts.calculatingTotal) {
                    dataToExport = this.insertEmptyRow(dataToExport);
                }
                const exportOptions = {
                    headers: headers,
                    quoteStrings: ''
                };
                return new ngxCsv(dataToExport, fileName, exportOptions);
            case 'pdf':
                let totalCount = 5;
                let totalArr: Array<any> = [];
                let pdfHeader: Array<any> = [];
                if (headers.length < 5) {
                    totalCount = headers.length;
                }
                for (let i = 0; i < totalCount; i++) {
                    pdfHeader.push(headers[i]);
                    if (i == totalCount - 2) {
                        totalArr.push("Total Count");
                    } else if (i == totalCount - 1) {
                        totalArr.push(data.length);
                    } else {
                        totalArr.push("");
                    }

                }
                let exportPDFData: any = data.map((item) => {
                    item = this.conditionalExportFormatting(item, opts);
                    const columnsData = [];
                    for (let k = 0; k < totalCount; k++) {
                        let temp: any = headerModal[k].field;
                        columnsData.push(item[temp]);
                    }
                    return columnsData;
                });
                exportPDFData.push(totalArr)
                const doc = new jsPDF();
                doc.autoTable(pdfHeader, exportPDFData, {
                    theme: 'plain'
                });
                doc.save(fileName + '.pdf');
                break;
            case 'excel':
                let excelRows: any[] = [];
                for (let j = 0; j < data.length; j++) {
                    let obj: any = {};
                    for (let k = 0; k < headerModal.length; k++) {
                        obj[headerModal[k].field] = data[j][headerModal[k].field];
                    }
                    obj = this.conditionalExportFormatting(obj, opts);
                    excelRows.push(obj);
                }
                if (opts.calculatingTotal) {
                    excelRows = this.insertEmptyRow(excelRows);
                }
                this.excelService.exportAsExcelFile(excelRows, fileName, headers);
        }

    }

    /**
     * Function used for clear input value when we click on cross icon while searching in p-table
     * @param input Input used for search
     * @param table Table to filter
     * @param data Table data
     */
    clearPrimeNgTableSearch(input, table, data): void {
        input.nativeElement.value = '';
        table.filteredValue = null;
        table.totalRecords = data.length;
    }

    /**
     * Function used for clear input value when we click on cross icon while searching in p-table
     * @param dataList List of data
     * @param calculateAtv whether to calculate Atv
     */
    calculateExtraFields(dataList, calculateAtv: boolean = false) {
        dataList.forEach((data) => {
            if (data.qty && data.amt) {
                data.aiv = data.amt / data.qty;
            } else {
                data.aiv = 0;
            }
            if (data.qty && data.customer_qty) {
                data.items_per_ticket = data.qty / data.customer_qty;
            } else {
                data.items_per_ticket = 0;
            }
            if (calculateAtv) {
                if (data.net_sales_amt && data.customer_qty && data.customer_qty) {
                    data.atv = data.amt / data.customer_qty;
                } else {
                    data.atv = 0;
                }
            }
        });
        return dataList;
    }

    calculateExtraFieldsForDept(dataList) {
        dataList.forEach((data) => {
            if (data.net_sales_qty != 0 && data.net_sales_qty != null && data.net_sales_amt != null) {
                data.aiv = data.net_sales_amt / data.net_sales_qty;
            } else {
                data.aiv = 0;
            }
            if (data.customer_qty != 0 && data.customer_qty != null) {
                data.items_per_ticket = data.net_sales_qty / data.customer_qty;
            } else {
                data.items_per_ticket = 0;
            }

            if (data.net_sales_amt != null && data.customer_qty != 0 && data.customer_qty != null) {
                data.atv = data.net_sales_amt / data.customer_qty;
            } else {
                data.atv = 0;
            }
        });
        return dataList;
    }

    /**
     * To sort Array based on Id
     * @param data Array to Sort
     */
    sortArray(data) {
        data.sort(function (a, b) {
            return a.id - b.id;
        });
        return data;
    }

    /**
     * For getting Selected columns after toggled from the dropdown
     * @param data Columns data
     */
    onColChange(data) {
        if (data.event.value.length === 0) {
            data.selectedColumns = data.colGroupName;
            this.saveColumnsOrder(data.selectedColumns, data.colData, 'REMOVE_ALL');
        } else if (data.event.value.length === 1) {
            this.saveColumnsOrder(data.selectedColumns, data.colData, 'REMOVE_ALL');
        }
        return data.selectedColumns;
    }

    /**
     * this will insert the empty row before the last total
     * @param data Rows data
     */

    insertEmptyRow(data) {
        const emptyObj = {};
        Object.keys(data[0]).forEach((field) => {
            emptyObj[field] = '';
        });
        data.splice(data.length - 1, 0, emptyObj);
        return data;
    }

    /**
     * To translate toggle columns dropdown name
     * @param columns Toggle columns
     */
    translateColDropdown(columns) {
        for (let i = 0; i < columns.length; i++) {
            columns[i].label = columns[i].value.label;
        }
        return columns;
    }

    /**
     * To display ngx-select dropdown visible when option is selected
     */
    onMultiSelect() {
        setTimeout(() => {
            const multiSelectDropdown = document.getElementsByClassName('ngx-select__choices');
            multiSelectDropdown[0].classList.add('show');
        });
    }

    /**
     * To get selected location obj from location list
     * @param activatedRoute Activated route Id to get from
     * @param locationList Location list
     *
     *
     */

    getMultiSelLocationObj(activatedRoute, locationList) {
        const dataObj = {};
        const selLocation = activatedRoute.snapshot.queryParamMap.params.location;
        if (selLocation) {
            dataObj['selLocId'] = Array.isArray(selLocation) ? selLocation : [selLocation];
        } else {
            dataObj['selLocId'] = locationList && [locationList[0].value];
        }
        return dataObj;
    }

    getMultiSelItemsLocationObj(activatedRoute, locationList, departmentList) {
        const dataObj = {};
        const selLocation = activatedRoute.snapshot.queryParamMap.params;
        if (selLocation.location && selLocation.department) {
            dataObj['selLocId'] = Array.isArray(selLocation.location) ? selLocation.location : [selLocation.location];
            dataObj['selDepId'] = Array.isArray(selLocation.department) ? selLocation.department : [selLocation.department];
        } else {
            this.router.navigate(['sales/locationItems']);
            return false;
        }
        return dataObj;
    }

    getSelLocationObj(activatedRoute, locationList) {
        const dataObj = {};
        const selLocation = activatedRoute.snapshot.queryParamMap.get('location');
        if (selLocation) {
            dataObj['selLocId'] = +selLocation;
            for (const loc of locationList) {
                if (loc.value === +selLocation) {
                    dataObj['selLocObj'] = loc;
                    break;
                }
            }
        } else {
            dataObj['selLocId'] = locationList && locationList[0].value;
        }
        return dataObj;
    }

    /**
     * To sort array alphabetically
     * @param data Array to sort
     */
    sortAlphabetically(data: any) {
        if (data?.length) {
            for (const obj of data) {
                if (obj.name === undefined || obj.name === null) {
                    obj.name = " ";
                }
                if (obj.connectorName === undefined || obj.connectorName === null) {
                    obj.connectorName = " ";
                }
                if (obj.username === undefined || obj.username === null) {
                    obj.username = " ";
                }
                if (obj.description === undefined || obj.description === null) {
                    obj.description = " ";
                }
                if (obj.label === undefined || obj.label === null) {
                    obj.label = " ";
                }
            }
        }
        data.sort(function (a, b) {
            const nameA = a.connectorName ? a.connectorName.toUpperCase() : a.username ? a.username.toUpperCase() : a.name ? a.name.toUpperCase() : a.description ? a.description.toUpperCase() : a.label.toUpperCase();
            const nameB = b.connectorName ? b.connectorName.toUpperCase() : b.username ? b.username.toUpperCase() : b.name ? b.name.toUpperCase() : b.description ? b.description.toUpperCase() : b.label.toUpperCase();
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
        return data;
    }

    /**
     * To format display date based on selected language
     * @param date Date to format
     * @param format Language format
     */
    formatDisplayDate(date, format) {
        let formattedDate;
        let newDate;
        let timepart;
        if (date.indexOf("T") > -1) {
            newDate = date.split('T')[0];
            timepart = date.split('T')[1];
        } else {
            newDate = date
            timepart = "";
        }
        const splittedDate = newDate.split('-');
        switch (format) {
            case 'en':
                formattedDate = `${splittedDate[1]}/${splittedDate[2]}/${splittedDate[0]}`;
                break;
            case 'fr':
                formattedDate = `${splittedDate[2]}/${splittedDate[1]}/${splittedDate[0]}`;
                break;
        }
        if (timepart) {
            return (formattedDate + " " + timepart);
        } else {
            return formattedDate;
        }

    }

    /**
     * To split ISO date
     * @param date Date to split
     */
    splitISODate(date: any, format?: any) {
        const splittedDate = date.split('T');
        if (format) {
            const formattedDate = this.formatDisplayDate(splittedDate[0], format);
            return formattedDate;
        } else {
            return splittedDate[0];
        }
    }

    showToasterMessage(type, message, detail) {
        this.messageService.clear();
        setTimeout(() => {
            this.messageService.add({ severity: type, summary: this.translate.instant(message), detail: detail });
        }, 0)
    }

    /**
     * Generic method to prepare hierarchical json
     * @author Prajesh Rai
     * @param result
     * @param depth
     * @param counter
     * @param updateResponse
     */
    genricHierachy(result, depth, counter, updateResponse) {
        if (result) {
            for (let i = counter; i <= result.length - 1; i += 1) {
                const obj = result[i];
                let hierarchyObj;
                if (obj.depth === depth) {
                    hierarchyObj = {
                        data: obj,
                    };
                    hierarchyObj.data["counter"] = hierarchyObj.data["depth"];
                    hierarchyObj.data["region"] = this.genricHierachy(result, depth + 1, i + 1, []);
                    hierarchyObj.data["children"] = hierarchyObj.data["region"];
                }
                if (obj.depth < depth) {
                    break;
                }
                if (hierarchyObj) {
                    updateResponse.push(hierarchyObj.data);
                }
            }
        }
        return updateResponse;
    }

    genericHierarchyCheckbox(result: any, depth: any, counter: any, updateResponse: any) {
        if (result) {
            for (let i = counter; i <= result.length - 1; i += 1) {
                const obj = result[i];
                let hierarchyObj;
                if (obj.depth === depth) {
                    hierarchyObj = {
                        data: obj,
                    };
                    //   hierarchyObj.data["counter"]=hierarchyObj.data["depth"];
                    //   hierarchyObj.data["region"]=this.genricHierachy(result, depth + 1, i + 1, []);
                    hierarchyObj.data["children"] = this.genericHierarchyCheckbox(result, depth + 1, i + 1, []);
                }
                if (obj.depth < depth) {
                    break;
                }
                if (hierarchyObj) {
                    if (hierarchyObj.data.children.length) {
                        hierarchyObj.data.leaf = false;
                        let sortedHierarchy = this.getSortedHierarchy(hierarchyObj.data.children, 'dropdown');
                        let sortedArray = this.getFinalArray(sortedHierarchy);
                        let finalSortedArray: any = {};
                        finalSortedArray = hierarchyObj.data;
                        finalSortedArray.children = sortedArray;
                    } else {
                        hierarchyObj.data.leaf = true;
                    }
                    updateResponse.push(hierarchyObj.data);
                }
            }
        }
        return updateResponse;
    }
    /**
     * Function to update location list after CRUD operation on locations and region hierarchies
     */
    updateLocationList(type?: any) {
        const loggedInUserData: any = JSON.parse(localStorage.getItem('userProfileData'));
        const graphqlObjToSend = {
            'query': getLocationHierarchyData,
            'variables': {
                "companyId": Number(localStorage.getItem('companyId')),
                "userId": loggedInUserData['userId']
            }
        }
        this.sharedService.getCommonGraphqlData(graphqlObjToSend).subscribe((response) => {
            const responseData: any = response.data['getLocationHierarchy'].depsHierJsons[0];
            localStorage.setItem('locationResponseData', JSON.stringify(responseData));
        });
    }


    /**
  * To get levels list
  */
    getLevels() {
        return new Promise((resolve) => {
            let levelsFilter = {};
            let levels: Array<any> = [];
            let levelsList: Array<any> = [];
            const getLevelsUrl = appConfig.updateLevel;
            this.sharedService.getData(getLevelsUrl)
                .subscribe((response) => {
                    levelsList = this.sortArray(response);
                    levels = this.createNamesArray(levelsList);
                    if (localStorage.getItem('levelsFilter')) {
                        levelsFilter = JSON.parse(localStorage.getItem('levelsFilter'));
                    }
                    levelsFilter['levels'] = levels;
                    levelsFilter['isGlobalFilter'] = false;
                    localStorage.setItem('levelsFilter', (JSON.stringify(levelsFilter)));
                    resolve(true);
                }, (error) => {
                    this.sharedService.serverErrorHandler(error);
                });
        });
    }

    /**
     * To get all location hierarchies
     */
    getLocationHierarchy() {
        return new Promise((resolve) => {
            let levelsFilter = {};
            const loggedInUserData: any = JSON.parse(localStorage.getItem('userProfileData'));
            const graphqlObjToSend = {
                'query': getRegionHierarchyData,
                'variables': {
                    "companyId": Number(localStorage.getItem('companyId')),
                    "userId": loggedInUserData['userId']
                }
            }
            this.sharedService.getCommonGraphqlData(graphqlObjToSend).subscribe((response) => {
                if (localStorage.getItem('levelsFilter')) {
                    levelsFilter = JSON.parse(localStorage.getItem('levelsFilter'));
                }
                levelsFilter['locHier'] = response.data['getRegionHierarchy'].regHierJsons[0];
                localStorage.setItem('levelsFilter', (JSON.stringify(levelsFilter)));
                resolve(true);
            }, (error) => {
                this.sharedService.serverErrorHandler(error);
            });
        });
    }

    /**
     * To get all locations
     */
    getLocations() {
        return new Promise((resolve) => {
            let levelsFilter = {};
            const loggedInUserData: any = JSON.parse(localStorage.getItem('userProfileData'));
            const graphqlObjToSend = {
                'query': getAllLocationData,
                'variables': {
                    "companyId": Number(localStorage.getItem('companyId')),
                    "userId": loggedInUserData['userId']
                }
            }
            this.sharedService.getCommonGraphqlData(graphqlObjToSend).subscribe((response) => {
                if (localStorage.getItem('levelsFilter')) {
                    levelsFilter = JSON.parse(localStorage.getItem('levelsFilter'));
                }
                levelsFilter['locations'] = response.data['getAllLocations'].getAllLocationsJsons[0];
                localStorage.setItem('levelsFilter', (JSON.stringify(levelsFilter)));
                resolve(true);
            }, (error) => {
                this.sharedService.serverErrorHandler(error);
            });
        });
    }

    /**
     * To get parentIds of selected location
     * @param location
     */
    getParentRegionLocationId(location: any[]) {
        const levelsFilter = localStorage.getItem('levelsFilter') ? JSON.parse(localStorage.getItem('levelsFilter')) : '';
        const locHier = levelsFilter['locHier'] ? levelsFilter['locHier'] : [];
        const levels = levelsFilter['levels']
        const selectedLocIds = [];

        if (location && location.length > 0) {
            location.forEach(loc => {
                locHier.forEach(lhier => {
                    if (lhier['id'] === loc) {
                        let groupId = lhier['groupid'];
                        if (groupId) {
                            selectedLocIds.push(groupId);
                        }
                        for (let i = 0; i < levels.length - 1; i++) {
                            locHier.forEach(loch => {
                                if (loch['id'] === groupId) {
                                    groupId = loch['groupid'];
                                    if (groupId) {
                                        selectedLocIds.push(groupId);
                                    }
                                }
                            });
                        }
                    }
                });
                selectedLocIds.push(loc);
            });
        }
        return Array.from(new Set(selectedLocIds));
    }

    /**
     * To get region location data
     */
    getLocationResponseData() {
        let levelsFilter = {};
        return new Promise((resolve) => {
            const loggedInUserData: any = JSON.parse(localStorage.getItem('userProfileData'));
            const graphqlObjToSend = {
                'query': getLocationHierarchyData,
                'variables': {
                    "companyId": Number(localStorage.getItem('companyId')),
                    "userId": loggedInUserData['userId']
                }
            }
            this.sharedService.getCommonGraphqlData(graphqlObjToSend).subscribe((response) => {
                const responseData: any = response.data['getLocationHierarchy'].depsHierJsons[0];
                let selectedLocationId: Array<any> = [];
                if (responseData) {
                    responseData.forEach((region: any) => {
                        selectedLocationId.push(region.reg_loc_id);
                    });
                    if (localStorage.getItem('levelsFilter')) {
                        levelsFilter = JSON.parse(localStorage.getItem('levelsFilter'));
                    }
                    levelsFilter['locationResponseData'] = responseData;
                    localStorage.setItem('levelsFilter', (JSON.stringify(levelsFilter)));
                    localStorage.setItem('locationResponseData', JSON.stringify(responseData));
                    localStorage.setItem('selectedLocationId', JSON.stringify(selectedLocationId));
                    localStorage.setItem('selectedLocationIdOverview', JSON.stringify(selectedLocationId));
                    localStorage.setItem('selectedLocationIdStoreOverview', JSON.stringify(selectedLocationId));
                    localStorage.setItem('selectedLocationIdTerminal', JSON.stringify(selectedLocationId));
                    localStorage.setItem('selectedLocationIdDepartment', JSON.stringify(selectedLocationId));
                    localStorage.setItem('selectedLocationIdStoreDepartment', JSON.stringify(selectedLocationId));
                    localStorage.setItem('selectedLocationIdItems', JSON.stringify(selectedLocationId));
                    localStorage.setItem('selectedLocationIdTender', JSON.stringify(selectedLocationId));
                    localStorage.setItem('selectedLocationIdStoreTender', JSON.stringify(selectedLocationId));
                    localStorage.setItem('selectedLocationIdSummary', JSON.stringify(selectedLocationId));
                    localStorage.setItem('selectedLocationIdCashiers', JSON.stringify(selectedLocationId));
                    localStorage.setItem('selectedLocationIdTransaction', JSON.stringify(selectedLocationId));
                    localStorage.setItem('selectedLocationIdsDoubleUp', JSON.stringify(selectedLocationId));
                    localStorage.setItem('selectedLocIdsDigitalReceipt', JSON.stringify(selectedLocationId));
                    localStorage.setItem('selectedLocationIdsLaneReboot', JSON.stringify(selectedLocationId));                    
                }
                resolve(true);
            }, (error) => {
                this.sharedService.serverErrorHandler(error);
            });
        });
    }

    // To gets the all data point
    getAllDataPointList() {
        return new Promise((resolve) => {
            const getDataPointListUrl = appConfig.getDataPointUrl;
            this.sharedService.getData(getDataPointListUrl).subscribe((response) => {
                localStorage.setItem('AllDataPointList', (JSON.stringify(response)));
                resolve(true);
            }, (error) => {
                this.sharedService.serverErrorHandler(error);
            });
        });
    }

    generateSHA256(inputString: string) {
        const trimmedInput = inputString.trim();
        if (trimmedInput) {
            return CryptoJS.SHA256(trimmedInput).toString();
        }
    }
}
